import moment from 'moment'
const filters={
    //价格过滤
    price:function (data) {
        return (data/100).toFixed(2)
    },
    //手机号隐藏中间4位
    phone:function (tel) {
        var reg = /^(\d{3})\d{4}(\d{4})$/;
        return tel.replace(reg, "$1****$2");
    },
    //时间戳转日期过滤器
    mtimestamp:function (time,type,division='-') {
        if(time==0 || !time){
            return '--'
        }
        if((time+'').length==10){
            time=time*1000
        }
        if(type==1){//只显示年月日
            return moment(time).format(`YYYY${division}MM${division}DD`)
        }
        if(type==3){
            return moment(time).format(`YYYY${division}MM${division}DD HH:mm:ss`)
        }
        return moment(time).format(`YYYY${division}MM${division}DD HH:mm:ss`)

    },
    //获取小时：分钟
    time:function (second) {
        var days = Math.floor(second / 86400);
        var hours = Math.floor((second % 86400) / 3600);
        var minutes = Math.floor(((second % 86400) % 3600) / 60);
        var seconds = Math.floor(((second % 86400) % 3600) % 60);
        // var duration = days + "天" + hours + "小时" + minutes + "分" + seconds + "秒";
        hours=hours<10 ? '0'+hours :hours;
        minutes=minutes<10 ? '0'+minutes :minutes;
        var duration =hours + ":" + minutes;
        return duration;
    },
    //序号过滤器
    No:function (index,number,page) {
        let No
        if(number && page){
            No=(index+1)+(page*number-number);
        }else{
            No=index+1;
        }
        return No<10 ? '0'+No : No;
    }
}

export default filters



// WEBPACK FOOTER //
// ./src/assets/js/filters.js